import Slider from "../components/sliders";
document.addEventListener("DOMContentLoaded", (e) => {
	const news_slider = document.querySelectorAll(".news-slider");
	if (news_slider) {
		news_slider.forEach((slider) => {
			const swiper = slider.querySelector(".swiper");
			if (swiper) {
				Slider.initSwiper(swiper, {
					loop: true,
					effect: "fade",
					slidesPerView: 1,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
				});
			}
		});
	}

	const highlight_box = document.querySelector(".highlight-box");
	if (highlight_box) {
		const close_box = highlight_box.querySelector(".highlight-box__close");
		close_box.addEventListener("click", (e) => {
			highlight_box.classList.add("is-hidden");
		});
	}
});
